__turbopack_context__.v({
  "increaseVisibilityButton": "index-module-scss-module__GZcxxq__increaseVisibilityButton",
});
